// import MomentUtils from '@date-io/moment';
// import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DateAdapter from "@mui/lab/AdapterMoment";

// components
import DialogPicker from "./DialogPicker";
import RangeDatePicker from "./RangePicker";
import TimePicker from "./TimePicker";
import InlinePicker from "./InlinePicker";
import WeekPicker from "./WeekPicker";

const DatePicker = (props) => {
  const { variant } = props;

  return (
    <LocalizationProvider dateAdapter={DateAdapter}>
      {variant === "inline" && <InlinePicker {...props} />}
      {variant === "dialog" && <DialogPicker {...props} />}
      {variant === "range" && <RangeDatePicker {...props} />}
      {variant === "time" && <TimePicker {...props} />}
      {variant === "week" && <WeekPicker {...props} />}
    </LocalizationProvider>
  );
};

export default DatePicker;
